import { logger } from '@awpmarine/core/logger';
import { createRouter as createTanStackRouter } from '@tanstack/react-router';

import { ErrorPage } from './components/error-page';
import { NotFound } from './components/not-found';
import { deLocalizeUrl, localizeUrl } from './paraglide/runtime';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  return createTanStackRouter({
    routeTree,
    defaultPreload: 'intent',
    // Without a delay this fires on `mouseenter` with nothing to cancel on leave, so a cursor
    // crossing the header pulls a route's chunk. Long enough that only a deliberate hover counts.
    defaultPreloadDelay: 150,
    scrollRestoration: true,
    // Covers a client-side navigation to an unknown URL; a direct hit is served `404.html` by the
    // host instead, which is the same component pre-rendered.
    defaultNotFoundComponent: NotFound,
    // A page that throws while rendering or loading; the error still reaches Dash0 through the logger.
    defaultErrorComponent: ErrorPage,
    defaultOnCatch: (error) => logger.error('Page failed to render: {error}', { error }),
    // Routes are written once; `/zh/about` matches `/about`, and links render in the page's locale.
    rewrite: {
      input: ({ url }) => deLocalizeUrl(url),
      output: ({ url }) => localizeUrl(url),
    },
  });
}
